/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/prefer-regexp-exec */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import pkg from '../../../../../package.json';

export function getAppVersion(): string {
  const version = pkg?.version as string;
  return version;
}

export function getAppName(): string {
  const name = pkg?.name as string;
  return name;
}

export function getDeviceType(): string {
  const userAgent = navigator.userAgent;
  let browserName;
  let device;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = 'Chrome';
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'Firefox';
  } else if (userAgent.match(/safari/i)) {
    browserName = 'Safari';
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'Opera';
  } else if (userAgent.match(/edg/i)) {
    browserName = 'Edge';
  } else if (userAgent.match(/android/i)) {
    browserName = 'Android';
  } else if (userAgent.match(/iphone/i)) {
    browserName = 'iPhone';
  } else {
    browserName = 'Unknown';
  }

  if ('ontouchstart' in document.documentElement) {
    device = 'mobile';
  } else {
    device = 'desktop';
  }

  //browserName (Chrome, Firefox, etc), device (mobile/desktop), lastValue (browser/native)
  return browserName + '-' + device + '-' + 'browser';
}
